var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"check_animated_icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 52 52"}},[_c('path',{attrs:{"fill":"none","d":"M14.1 27.2l7.1 7.2 16.7-16.8"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }